module.exports = __webpack_public_path__ + "static/media/booth-lines.e3c71090.svg";